import { isDefined, getDefined, allOf } from '../../../utils/util';

const singletonId = Symbol();
const singletonEnforcer = Symbol();

class StatModel {
  constructor(enforcer) {
    if (enforcer !== singletonEnforcer) throw new Error('StatModel can not use construct. use getInstance method');

    /*
    update wiki list
    2019.08
    2019.11
    2021.05 CSDT-547
    2021.12 CSDT-818
     */

    const _ = this;

    _.LEVEL_INIT = 50;

    _.LEVEL_MAX = 100;
    // 엘릭서 elixir level  99 -> 100 2022.1.
    // 엘릭서 elixir level 75 -> 95  2019.08
    // 95 -> 99 (2020.09)

    _.LEVEL_USABLE_ELIXIR_POINT = 100;
    // 99 -> 100 // 2022.1.

    _.STAT_MAX_AT_LEVEL_INIT = 20;
    /* 2021.05.12 초기 스탯 최대값 셋팅 업데이트 */
    // 16 > 23
    _.STAT_MAX_AT_LEVEL_INIT_DEX_0 = 18; // 군주
    _.STAT_MAX_AT_LEVEL_INIT_INT_0 = 18;
    _.STAT_MAX_AT_LEVEL_INIT_DEX_4 = 19; // 다크엘프
    _.STAT_MAX_AT_LEVEL_INIT_INT_4 = 18;
    _.STAT_MAX_AT_LEVEL_INIT_WIS_4 = 17;

    // 2019.11  90lv 미만 캐릭터의 스탯 한도 45 -> 50
    // 2021.12  100lv 이상 50 -> 55
    _.STAT_MAX = 50;

    // when level >= 90, stat max change 50 from 45.
    // 2019.11 90lv 이상 캐릭터의 스탯 한도 50 -> 55
    _.LEVEL_CHANGE_STAT_MAX = 90;
    _.CHANGED_STAT_MAX = 55;

    // 2021.12 100레벨이 되면 60 level -> targetLevel
    _.STAT_MAX_BY_LEVEL = [{level: 50, max: 50 }, {level: 90, max: 55 }, {level: 100, max: 60 }];

    _.STAT_LEVEL_COLORS = [{
      level: 25,
      class: 'em1'
    }, {
      level: 35,
      class: 'em2'
    }, {
      level: 45,
      class: 'em3'
    }];

    _.CHANGED_LEVEL_COLORS = [{
      level: 25,
      class: 'em1'
    }, {
      level: 35,
      class: 'em2'
    }, {
      level: 50,
      class: 'em3'
    }];



    _.PLUS_ELIXIR_POINT_BY_LEVEL = [{level: 80, point: 2 }, {level: 90, point: 2}, {level: 100, point: 3 }];
    _.PER_LEVEL_PLUS_ELIXIR_POINT = 2;
    // _.PER_LEVEL_PLUS_ELIXIR_POINT = 2; // 2022.01 엘렉서 50레벨부터 2레벨 당 + 1개, 80레벨일때만 +2개, 90레벨일때만 +2개, 100레벨일때만 +3개
    // _.PER_LEVEL_PLUS_ELIXIR_POINT = 3;  // 2019.11 엘릭서 50레벨부터 5레벨 당 + 1개 -> 3레벨 당 + 1개

    _.ELIXIR_POINT_INIT = 1;

    _.DEVICE_TYPE = '';

    _.DATA_INIT = null;

    _.SERVER_ID = '';

    _.CLASS_ID = '';

    // use only statSimulator page (pc, mobile)
    _.CHAR_NAME = '';

    _.USER_STAT_NUM_LIMIT = 6;
  }

  static getInstance() {
    if (!this[singletonId]) this[singletonId] = new StatModel(singletonEnforcer);
    return this[singletonId];
  }

  static getDefaultStatData(defaultStatDataFromApi, options = {
    page: '',
    type: '',
    classType: '',
    level: 0,
    elixirUseYN: false
  }) {
    const data = defaultStatDataFromApi,
      sub = data.formattedSubStat,
      attribute = allOf(isDefined(data), isDefined(sub)) ? sub.attribute : null;

    const json = {
      'page': options.page,

      'type': options.type,
      'classType': options.classType,

      // 'point' : (data) ? getDefined(data.remainStat, '0') : '-',
      'level': getDefined(data.level, options.LEVEL_INIT),

      'HP': '-', // getDefined(data.hp, '0'),
      'MP': '-', // getDefined(data.mp, '0'),

      'STR': getDefined(data.mainStat.STR, 0),
      'DEX': getDefined(data.mainStat.DEX, 0),
      'INT': getDefined(data.mainStat.INT, 0),
      'CON': getDefined(data.mainStat.CON, 0),
      'WIS': getDefined(data.mainStat.WIS, 0),
      'CHA': getDefined(data.mainStat.CHA, 0),

      // STR - use formattedSubStat
      'DAMAGE_SHORT': getDefined(sub.STR.damageShort, '0'),
      'HIT_SHORT': getDefined(sub.STR.hitShort, '0'),
      'FATAL_SHORT': getDefined(sub.STR.fatalShort, '0'),
      'WEIGHT': getDefined(sub.STR.weight, '0'),

      // DEX - use formattedSubStat
      'DAMAGE_LONG': getDefined(sub.DEX.damageLong, '0'),
      'HIT_LONG': getDefined(sub.DEX.hitLong, '0'),
      'FATAL_LONG': getDefined(sub.DEX.fatalLong, '0'),
      'AC': getDefined(sub.DEX.ac, '0'),
      'ER': getDefined(sub.DEX.er, '0'),

      // INT - use formattedSubStat
      'DAMAGE_WIZ': getDefined(sub.INT.damageWiz, '0'),
      'HIT_WIZ': getDefined(sub.INT.hitWiz, '0'),
      'FATAL_WIZ': getDefined(sub.INT.fatalWiz, '0'),
      'MB': getDefined(sub.INT.mb, '0'),
      'MP_MINUS': getDefined(sub.INT.mpMinus, '0'),

      // WIS - use formattedSubStat
      'LEVELUP_MP_PLUS_MIN': getDefined(sub.WIS.levelupMpPlus.min, '0'),
      'LEVELUP_MP_PLUS_MAX': getDefined(sub.WIS.levelupMpPlus.max, '0'),
      'MP_RECOVER_TIC': getDefined(sub.WIS.mpRecoverTic, '0'),
      'MP_RECOVER_LIQUOR': getDefined(sub.WIS.mpRecoverLiquor, '0'),
      'MR': getDefined(sub.WIS.mr, '0'),

      // CON - use formattedSubStat
      'LEVELUP_HP_PLUS_MIN': getDefined(sub.CON.hpPlus.min, '0'),
      'LEVELUP_HP_PLUS_MAX': getDefined(sub.CON.hpPlus.max, '0'),
      'HP_RECOVER_TIC_MIN': getDefined(sub.CON.hpRecoverTic.min, '0'),
      'HP_RECOVER_TIC_MAX': getDefined(sub.CON.hpRecoverTic.max, '0'),
      'HP_RECOVER_LIQUOR': getDefined(sub.CON.hpRecoverLiquor, '0'),
      // CON WEIGHT === STR WEIGHT

      // CHA  // 20211206
      'CHA_HIT_SIKII': getDefined(sub.CHA.hitSkill, '0'),
      'CHA_HIT_SUMMON': getDefined(sub.CHA.hitSummon, '0'),
      'CHA_HIT_DRAGON': getDefined(sub.CHA.hitDragon, '0'),
      'CHA_HIT_FEAR': getDefined(sub.CHA.hitFear, '0'),
      'CHA_SKILL_TIME_REDUCTION': getDefined(sub.CHA.skillTimeReduction, '0'),
      'CHA_STATUS_TIME_REDUCTION': getDefined(sub.CHA.statusTimeReduction, '0'),

      // attribute
      'FIRE': isDefined(attribute) ? getDefined(attribute.FIRE, '0') : '0',
      'WATER': isDefined(attribute) ? getDefined(attribute.WATER, '0') : '0',
      'STORM': isDefined(attribute) ? getDefined(attribute.STORM, '0') : '0',
      'LAND': isDefined(attribute) ? getDefined(attribute.LAND, '0') : '0',
      'HIT_SKILL': isDefined(attribute) ? getDefined(attribute.hitSkill, '0') : '0',
      'RES_SKILL': isDefined(attribute) ? getDefined(attribute.resSkill, '0') : '0',
      'HIT_SUMMON': isDefined(attribute) ? getDefined(attribute.hitSummon, '0') : '0',
      'RES_SUMMON': isDefined(attribute) ? getDefined(attribute.resSummon, '0') : '0',
      'HIT_DRAGON': isDefined(attribute) ? getDefined(attribute.hitDragon, '0') : '0',
      'RES_DRAGON': isDefined(attribute) ? getDefined(attribute.resDragon, '0') : '0',
      'HIT_FEAR': isDefined(attribute) ? getDefined(attribute.hitFear, '0') : '0',
      'RES_FEAR': isDefined(attribute) ? getDefined(attribute.resFear, '0') : '0',

      'remainStat': getDefined(data.remainStatPoint, '0'),
      'remainTotalStat': getDefined(data.remainStatPoint, '0'),
      'elixirStat': 1,
      'elixirTotalStat': 1,

      'elixirUseYN': getDefined(options.elixirUseYN, false)
    };

    return json;
  }

  static getSavedStatData(savedSimulationStat, savedUserStatInfo, options = {
    idex: '',
    page: '',
    type: ''
  }) {
    const data = savedSimulationStat,
      user = savedUserStatInfo,
      sub = data.formattedSubStat,
      attribute = allOf(isDefined(data), isDefined(sub)) ? sub.attribute : null;

    const json = {
      'idx': options.idx,
      'page': options.page,

      'type': options.type,
      'classType': user.classId,
      'targetLevel': user.targetLevel,

      'classImageUrl': user.classImageUrl,

      // 'point' : (data) ? getDefined(data.remainStat, '0') : '-',
      'level': data.level,

      'HP': data.hp,
      'MP': data.mp,

      'STR': data.mainStat.STR,
      'DEX': data.mainStat.DEX,
      'INT': data.mainStat.INT,
      'CON': data.mainStat.CON,
      'WIS': data.mainStat.WIS,
      'CHA': data.mainStat.CHA,

      // STR - use formattedSubStat
      'DAMAGE_SHORT': getDefined(sub.STR.damageShort, '0'),
      'HIT_SHORT': getDefined(sub.STR.hitShort, '0'),
      'FATAL_SHORT': getDefined(sub.STR.fatalShort, '0'),
      'WEIGHT': getDefined(sub.STR.weight, '0'),

      // INT - use formattedSubStat
      'DAMAGE_WIZ': getDefined(sub.INT.damageWiz, '0'),
      'HIT_WIZ': getDefined(sub.INT.hitWiz, '0'),
      'FATAL_WIZ': getDefined(sub.INT.fatalWiz, '0'),
      'MB': getDefined(sub.INT.mb, '0'),
      'MP_MINUS': getDefined(sub.INT.mpMinus, '0'),

      // DEX - use formattedSubStat
      'DAMAGE_LONG': getDefined(sub.DEX.damageLong, '0'),
      'HIT_LONG': getDefined(sub.DEX.hitLong, '0'),
      'FATAL_LONG': getDefined(sub.DEX.fatalLong, '0'),
      'AC': getDefined(sub.DEX.ac, '0'),
      'ER': getDefined(sub.DEX.er, '0'),

      // WIS - use formattedSubStat
      'LEVELUP_MP_PLUS_MIN': getDefined(sub.WIS.levelupMpPlus.min, '0'),
      'LEVELUP_MP_PLUS_MAX': getDefined(sub.WIS.levelupMpPlus.max, '0'),
      'MP_RECOVER_TIC': getDefined(sub.WIS.mpRecoverTic, '0'),
      'MP_RECOVER_LIQUOR': getDefined(sub.WIS.mpRecoverLiquor, '0'),
      'MR': getDefined(sub.WIS.mr, '0'),

      // CON - use formattedSubStat
      'LEVELUP_HP_PLUS_MIN': getDefined(sub.CON.hpPlus.min, '0'),
      'LEVELUP_HP_PLUS_MAX': getDefined(sub.CON.hpPlus.max, '0'),
      'HP_RECOVER_TIC_MIN': getDefined(sub.CON.hpRecoverTic.min, '0'),
      'HP_RECOVER_TIC_MAX': getDefined(sub.CON.hpRecoverTic.max, '0'),
      'HP_RECOVER_LIQUOR': getDefined(sub.CON.hpRecoverLiquor, '0'),
      // CON WEIGHT === STR WEIGHT

      // CHA  // 20211206
      'CHA_HIT_SIKII': getDefined(sub.CHA.hitSkill, '0'),
      'CHA_HIT_SUMMON': getDefined(sub.CHA.hitSummon, '0'),
      'CHA_HIT_DRAGON': getDefined(sub.CHA.hitDragon, '0'),
      'CHA_HIT_FEAR': getDefined(sub.CHA.hitFear, '0'),
      'CHA_SKILL_TIME_REDUCTION': getDefined(sub.CHA.skillTimeReduction, '0'),
      'CHA_STATUS_TIME_REDUCTION': getDefined(sub.CHA.statusTimeReduction, '0'),

      // attribute
      'FIRE': isDefined(attribute) ? getDefined(attribute.FIRE, '0') : '0',
      'WATER': isDefined(attribute) ? getDefined(attribute.WATER, '0') : '0',
      'STORM': isDefined(attribute) ? getDefined(attribute.STORM, '0') : '0',
      'LAND': isDefined(attribute) ? getDefined(attribute.LAND, '0') : '0',
      'HIT_SKILL': isDefined(attribute) ? getDefined(attribute.hitSkill, '0') : '0',
      'RES_SKILL': isDefined(attribute) ? getDefined(attribute.resSkill, '0') : '0',
      'HIT_SUMMON': isDefined(attribute) ? getDefined(attribute.hitSummon, '0') : '0',
      'RES_SUMMON': isDefined(attribute) ? getDefined(attribute.resSummon, '0') : '0',
      'HIT_DRAGON': isDefined(attribute) ? getDefined(attribute.hitDragon, '0') : '0',
      'RES_DRAGON': isDefined(attribute) ? getDefined(attribute.resDragon, '0') : '0',
      'HIT_FEAR': isDefined(attribute) ? getDefined(attribute.hitFear, '0') : '0',
      'RES_FEAR': isDefined(attribute) ? getDefined(attribute.resFear, '0') : '0',

      'remainStat': user.statPointInfo.remainStatPoint,
      'remainTotalStat': user.statPointInfo.totalStatPoint,
      'elixirStat': user.statPointInfo.remainElixirPoint,
      'elixirTotalStat': user.statPointInfo.totalElixirPoint,

      'elixirUseYN': user.statPointInfo.usedElixir
    };

    return json;
  }
}

export default StatModel;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/stat/StatModel.js